var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgLinkIcon = function SvgLinkIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.536 8.936a.97.97 0 0 0 1.37 0l.684-.683c1.88-1.88 1.88-4.962 0-6.841-1.88-1.883-4.962-1.883-6.842 0L6.685 4.471c-1.88 1.88-1.88 4.961.003 6.84a.966.966 0 1 0 1.367-1.366 2.91 2.91 0 0 1 0-4.107l3.06-3.06a2.912 2.912 0 0 1 4.108 0 2.907 2.907 0 0 1 0 4.104l-.687.687a.966.966 0 0 0 0 1.367zM3.461 9.06a.966.966 0 0 0-1.368 0l-.683.686c-1.88 1.88-1.88 4.962 0 6.841 1.88 1.883 4.96 1.883 6.842 0l3.06-3.059a4.852 4.852 0 0 0 0-6.844.966.966 0 0 0-1.367 0 .97.97 0 0 0 0 1.37 2.91 2.91 0 0 1 0 4.104l-3.063 3.062a2.914 2.914 0 0 1-4.105 0 2.91 2.91 0 0 1 0-4.107l.684-.683a.97.97 0 0 0 0-1.37z",
    fill: "#616770",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLinkIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/link-icon.86dc26cf.svg";
export { ForwardRef as ReactComponent };